import React from "react";
import AgBulkTable from "../../Analyze/AnalyzeTransactionsTable/AgBulkTable";
import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { performBulkEdit } from "../../../../docuclipper/api";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  fetchMfs,
  setTls,
  toggleLoading,
} from "../../../../redux/reducers/TransactionManager";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import { createAlert } from "../../../../redux/reducers/Alerts";
import { AddTransactionModal } from "./AddTransaction";
import SelectAccount2 from "./ReassignAccount/SelectAccount2";
type Props = {
  defaultColDef;
  rowData;
  columnDefs;
  paginationPageSizeSelector?;
  pagination?;
  paginationPageSize?;
  paginationAutoPageSize?;
  onGridReady?;
  onSetApi?;
};
export const NewTransactionTable: React.FC<Props> = ({
  defaultColDef,
  rowData,
  columnDefs,
  onSetApi,
  ...rest
}) => {
  const { job } = useSelector((state: ReduxState) => state.JobData);
  const dispatch = useDispatch();
  const bulkEditHelper = (operation, transactionIds) => {
    if (!job) {
      return Promise.resolve();
    }
    dispatch(toggleLoading());
    return performBulkEdit({
      jobId: job.id,
      operation,
      params: {},
      transactionIds,
    })
      .then(({ transactions }) => {
        dispatch(toggleLoading());
        dispatch(setTls({ transactions, resetPages: false }));

        dispatch(fetchTotals());
        dispatch(fetchMfs());

        // dispatch(fetchJobDocuments());
        // dispatch(fetchTls());
        dispatch(
          createAlert({
            message: "Correction made successfully",
            timeout: 0,
            type: "success",
          })
        );
        // dispatch(setSelectedRowIds({}));
      })
      .catch((err) => {
        dispatch(toggleLoading());
        dispatch(
          createAlert({
            message: "Error making correction",
            timeout: 0,
            type: "error",
          })
        );
      });
  };

  // const { tableGridApi } = useSelector(
  //   (state: ReduxState) => state.TransactionManager
  // );
  return (
    <>
      {/* <Row className="justify-content-end">
        <div className="m-2"></div>
      </Row> */}

      <AgBulkTable
        onSetApi={onSetApi}
        bulkOpsClassName={"new-transactions-bulk-operations"}
        renderBulkOps={(data, setSelectedRowsIds) => {
          const transactionIds = data.map((x) => x.id);
          return (
            <>
              <Row className="justify-content-between mb-2">
                <Col md="8">
                  <Row>
                    <SelectAccount2
                      transactionIds={transactionIds}
                      setSelectionError={() => null}
                      onDone={() => setSelectedRowsIds([])}
                    />
                    <Button
                      disabled={data.length === 0}
                      variant="light"
                      onClick={() =>
                        bulkEditHelper("switchSigns", transactionIds).then(
                          () => {
                            if (setSelectedRowsIds) {
                              setSelectedRowsIds({});
                            }
                          }
                        )
                      }
                      className="m-1 ml-2"
                    >
                      <FontAwesomeIcon icon="random"></FontAwesomeIcon>
                      <span className="ml-1">Switch credits/debits</span>
                    </Button>
                    <Button
                      disabled={data.length === 0}
                      variant="light"
                      onClick={() =>
                        bulkEditHelper(
                          "switchIncludedExcluded",
                          transactionIds
                        ).then(() => {
                          if (setSelectedRowsIds) {
                            setSelectedRowsIds({});
                          }
                        })
                      }
                      className="m-1"
                    >
                      <FontAwesomeIcon icon="random"></FontAwesomeIcon>
                      <span className="ml-1">Switch included/excluded</span>
                    </Button>
                  </Row>
                </Col>
                <Col md="4">
                  <Row className="justify-content-end">
                    <div className="mx-2">
                      <AddTransactionModal
                        buttonVariant="light"
                        extended={true}
                      />
                    </div>
                  </Row>
                </Col>
              </Row>
            </>
          );
        }}
        hasExport={false}
        height={"75vh"}
        width={"100%"}
        defaultColDef={defaultColDef}
        colResizeDefault="shift"
        singleClickEdit
        rowData={rowData}
        columnDefs={columnDefs}
        {...rest}
      ></AgBulkTable>
    </>
  );
};
export default NewTransactionTable;
